/**
 * La decision unique du plafond d'acompte, partagee par les deux dialogues jumeaux
 * (evenements et formules) et par leur contrat de test.
 *
 * La propriete « la panne ferme » tient sur DEUX etages :
 *
 * 1. le CALCUL du plafond, dans les deux `compte-bancaire.service.ts` — sans repli
 *    sur `totalReverse`, un champ absent donne `NaN` ;
 * 2. la DECISION, ici — `montant <= NaN` rend `false`, donc toute saisie est
 *    refusee et le formulaire reste invalide.
 *
 * Les deux doivent etre exerces pour que la propriete soit gardee. Le contrat de
 * test recopiait cette decision au lieu de l'appeler : rendre le validateur
 * tolerant (`Number.isFinite(plafond) && montant > plafond`) aurait supprime le
 * message « maximum de NaN€ » ET ouvert le plafond, sans faire rougir un seul test.
 * D'ou cette extraction : une ligne, un seul appelant logique, une seule verite.
 *
 * ⚠️ NE PAS ajouter de garde sur `NaN` ici. C'est precisement `NaN` qui ferme.
 */
export function saisieDansLePlafond(montant: number, plafond: number): boolean {
  return montant <= plafond;
}
